import { User } from '../../user/User.interface';

export enum SessionSource {
  Web = 'web',
  Ios = 'ios',
  Android = 'Android'
}

export interface Session {
  user: User;
  clientId: string; // unique client generated id
  socketId: string; // id of the current socket
  source: SessionSource;
  path?: string; // url path user is currently viewing
}
